import Overview from './overview'
import Consultation from './consultation'
import LabTest from './labTests'
import Medicine from './medicine'
import Tabs from '@commons/tabs'
const PatientAppointmentTabs = ({
  userAppointment,
  values,
  setFieldValue,
}: any) => {
  const tabs: any = [
    {
      title: 'Overview',
      key: 'overview',
      Component: Overview,
      props: {
        userAppointment,
        values,
        setFieldValue,
      },
    },
    {
      title: 'Consultation',
      key: 'consultation',
      Component: Consultation,
      props: {
        userAppointment,
        values,
        setFieldValue,
      },
    },
    {
      title: 'Lab Tests',
      key: 'lab-test',
      Component: LabTest,
      props: {
        userAppointment,
        values,
        setFieldValue,
      },
    },
    {
      title: 'Medicine',
      key: 'medicine',
      Component: Medicine,
      props: {
        userAppointment,
        values,
        setFieldValue,
      },
    },
  ]
  return <Tabs items={tabs} />
}

export default PatientAppointmentTabs
